<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="区域"
      edit-title
      id-key="RegionId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="区域名称" prop="Name">
                <el-input v-model="data.Name" placeholder="请输入区域名称" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <div class="row-tb-head" style="margin-top: 10px">
          <span>地区列表</span>
          <div style="float: right">
            <el-button type="primary" @click="add">添加</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </div>
        </div>
        <el-table
          ref="table"
          class="table-line tb-c-head"
          @selection-change="handleSelectionChange"
          :data="areaList"
          border
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="Name"
            label="地区"
            min-width="110"
            align="center"
          />
        </el-table>
      </template>
    </common-dialog>
    <area-dialog
      ref="areaDialog"
      in-dialog
      selectable
      multiple
      @select-multiple="setArea"
    ></area-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import areaDialog from "@/components/basedata/basedoc/district/listDialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    areaDialog,
  },
  data() {
    return {
      data: {
        RegionId: 0,
        Name: "",
        DetailDtos: [],
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/region").default,
      // trendData: iForm.Data,
      showList: [],
      areaList: [],
      multipleSelection: [],
      rules: {
        Name: [{ required: true, message: "区域名称不能为空" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {},

    onEditOpened(data) {
       this.api.info(this.data.RegionId).then((res) => {
        this.areaList = res.Data.DetailDtos.reduce((arr, item) => {
          // arr.push({ RegionId: item.RegionId, Name: item.Name });
          arr.push(item);
          return arr;
        }, []);
        this.data = res.Data;
      });
    },
    setArea(data) {
      // console.log(emp);
      let areaId = this.areaList.map((item) => item.DistrictId);
      data.forEach((item) => {
        if (!areaId.includes(item.DistrictId))
          this.areaList.push({ DistrictId: item.DistrictId, Name: item.Name ,T:0});
      });
    },
    onBeforeSave() {
      // this.$message.warning("每个员工只能加入一个班组,该功能后续完善");
      if (this.data.DetailDtos.length == 0) return (this.data.DetailDtos = this.areaList);
      let delIds = this.areaList.map((item) => item.DistrictId);
      let delList = this.data.DetailDtos.reduce((arr, item) => {
        if (!delIds.includes(item.DistrictId)) arr.push({ ...item, T: 2 });
        return arr;
      }, []);

      let addIds = this.data.DetailDtos.map((item) => item.DistrictId);
      let addList = [];
      addList = this.areaList.reduce((arr, item) => {
        if (!addIds.includes(item.DistrictId)) arr.push({ ...item, T: 0 });
        return arr;
      }, []);

      this.data.DetailDtos = [...addList, ...delList];
      // console.log( this.data.DetailDtos);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    add() {
      this.$refs.areaDialog.open().then((that) => that.getData());
    },
    del() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let delList = this.multipleSelection.map((item) => item.DistrictId);
          let data = this.areaList.filter(
            (item) => !delList.includes(item.DistrictId)
          );
          this.areaList = JSON.parse(JSON.stringify(data));
        })
        .catch(() => {});
    },
    onClosed() {
      this.showList = [];
      this.multipleSelection = [];
      this.areaList = [];
      this.data.DetailDtos = [];
    },
  },
};
</script>